import { Component, Input, OnInit } from '@angular/core';
import { Ship } from '../../../Ship';
import { ShipRoundTripHistory } from '../../../data/ShipRoundTripHistory';
import { EntitlementService } from '../../../services/entitlement.service';
import { ShipReportService } from 'src/app/services/ship-report.service';
import { Router } from '@angular/router';
import {ShipInstallation} from "../../../data/ShipInstallation";

@Component({
  selector: 'app-round-trip-history',
  templateUrl: './round-trip-history.component.html',
  styleUrls: ['./round-trip-history.component.css']
})
export class RoundTripHistoryComponent implements OnInit {
  @Input() ship: Ship;
  @Input() shipRoundTripHistory: ShipRoundTripHistory;
  @Input() shipInstallations: ShipInstallation[];

  constructor(private entitlementService: EntitlementService, private shipReportService: ShipReportService, private router: Router) { }

  ngOnInit() { }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  gotoShipReports(lastRoundtripDetailBatchId: string) {
    const report = {
      'location': this.ship.shipLocation,
      'batch': lastRoundtripDetailBatchId
    };
    this.shipReportService.storeReport(report);
    this.router.navigate(['/reports/shipReports']);
  }

  updateShipData(newShip: Ship, newShipRoundTripHistory: ShipRoundTripHistory, shipInstallations: ShipInstallation[]) {
    this.ship = newShip;
    this.shipRoundTripHistory = newShipRoundTripHistory;
    this.shipInstallations = shipInstallations;
  }

}
